import React from "react"
import ModalWindow from "../common/ModalWindow";
import UploadDocumentForm from "./UploadDocumentForm";

interface IPropType {
    loanDetail: any,
    css: any,
    onSubmitComplete: any,
    children:any
}

class UploadDocumentButton extends React.Component<IPropType, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            showModal: false
        }
    }

    render() {
        const { showModal } = this.state;
        return (
            <React.Fragment>
                {
                    showModal && this.renderModal()
                }
                <button className={this.props.css} onClick={this.onShowModal}>
                    {this.props.children}
                </button>
            </React.Fragment>
        )
    }

    renderModal = () => {
        const { loanDetail } = this.props;
        return (
            <React.Fragment>
                <ModalWindow
                    title="Upload Document"
                    backdrop="static"
                    className="modal-md"
                    onCancel={this.onHideModal}
                >
                    <UploadDocumentForm
                        loanDetail={loanDetail}
                        onSubmitComplete={this.onSubmitComplete}
                    />
                </ModalWindow>
            </React.Fragment>
        )
    }

    onShowModal = (e: any) => {
        this.setState({ showModal: true })
    }

    onHideModal = () => {
        this.setState({ showModal: false })
    }

    onSubmitComplete = (detail: any) => {
        this.onHideModal();
        this.props.onSubmitComplete(detail);
    }
}

export default UploadDocumentButton;